import React from "react"
import Main from "./components/Main"
import {createRoot} from 'react-dom/client'; // Note the '/client' import

const container = document.getElementById('root');

if(container){
const root = createRoot(container);
root.render(<Main/>);
}
